jQuery(($) => {
    if ($('.o-page-navigation-bar')[0]) {
        $('.o-page-navigation-bar').each(function () {
            const $active      = $(this).find('.o-page-navigation-bar__link--active');
            const activeOffset = $active.offset().left;
            const activeWidth  = $active.innerWidth();

            const listScroll = $(this).scrollLeft();
            const listWidth  = $(this).width();

            $(this).scrollLeft(activeOffset + activeWidth / 2 + listScroll - listWidth / 2);
        });

        $('.o-page-navigation-bar').scroll(function () {

            if ($(window).width() <= 700) {
                const scroll      = $(this).scrollLeft();
                const width       = $(this).width();
                const scrollWidth = $(this).get(0).scrollWidth;

                if ((scrollWidth - scroll) <= width) {
                    if (!$('.o-page-navigation-bar--end')[0]) {
                        $(this).addClass('o-page-navigation-bar--end');
                    }
                } else {
                    if ($('.o-page-navigation-bar--end')[0]) {
                        $(this).removeClass('o-page-navigation-bar--end');
                    }
                }
            }
        });

        $(window).resize(function () {
            if ($(this).width() > 700 && $('.o-page-navigation-bar--end')[0]) {
                $('.o-page-navigation-bar').removeClass('o-page-navigation-bar--end');
            }
        });
    }
});